import script from "./otp2.vue?vue&type=script&setup=true&lang=js"
export * from "./otp2.vue?vue&type=script&setup=true&lang=js"

import "./otp2.vue?vue&type=style&index=0&id=7f71c0f6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f71c0f6"]])

export default __exports__